import LayerOne from '../../../../styles/animated/credit-check-loader/Layer_1.svg?url';
import LayerTwo from '../../../../styles/animated/credit-check-loader/Layer_2.svg?url';
import LayerThree from '../../../../styles/animated/credit-check-loader/Layer_3.svg?url';
import LayerFour from '../../../../styles/animated/credit-check-loader/Layer_4.svg?url';
import LayerFive from '../../../../styles/animated/credit-check-loader/Layer_5.svg?url';
import LayerSix from '../../../../styles/animated/credit-check-loader/Layer_6.svg?url';
import './credit-check-loader.css';

const CreditCheckLoader = () => {
  return (
    <div className='animation-layout margin-auto'>
      <img
        src={LayerOne}
        alt='animation'
        className='credit-check-loader-animate'
      />
      <img
        src={LayerTwo}
        alt='animation'
        className='credit-check-loader-animate'
      />
      <img
        src={LayerThree}
        alt='animation'
        className='credit-check-loader-animate'
      />

      <img
        src={LayerFour}
        alt='animation'
        className='credit-check-loader-animate'
      />
      <img
        src={LayerFive}
        alt='animation'
        className='credit-check-loader-animate'
      />
      <img
        src={LayerSix}
        alt='animation'
        className='credit-check-loader-animate'
      />
    </div>
  );
};

export default CreditCheckLoader;
